import { Typography, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useBasketLinkContext } from '~/contexts';
import { translationKeys } from '~/models';

const Root = styled('div')(({ theme }) => ({
  height: 65,
  position: 'absolute',
  zIndex: 2,
  display: 'flex',
  padding: theme.spacing(0, 4),
  boxSizing: 'border-box',
  alignItems: 'center',
  width: '100%',
  background: 'linear-gradient(to bottom, #fff 20%, rgba(255,255,255,0.9) 30%)',
  color: theme.palette.text.secondary,
}));

const BasketLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
}));

export const Header: FC<{ quantity: number }> = ({ quantity }) => {
  const basketLink = useBasketLinkContext();
  const { getTestId } = useTestId();

  return (
    <Root data-testid={getTestId('header')}>
      <Typography variant="h6">
        <BasketLink
          href={basketLink}
          data-testid={getTestId('header-basket-link')}
        >
          <FormattedMessage id={translationKeys.basket} /> ({quantity.toString()})
        </BasketLink>
      </Typography>
    </Root>
  );
};
